// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-container{gap:0!important}.time-layout-duration{display:block}.time-layout-duration img{width:100%;height:200px;-o-object-fit:cover;object-fit:cover;margin:0 auto;border-radius:15px}.btn-booking{padding-top:10px}.btn-booking button{width:100%;border-radius:50px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
